import * as React from 'react';
import { Trans } from 'react-i18next';
import s from '../../Cycles/Cycles.scss';
import classNames from 'classnames';
import {
  PremiumCurrencyFormatter,
  CurrencyAndFormatToString,
} from '@wix/premium-react-text';
import { CycleDetails } from 'types';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { Text } from '@wix/design-system';
import { withInjectedRootStore, RootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Theme } from 'enums';

export interface SaleDiscountBadgeProps extends InjectedExperimentsProps {
  monthlyFullPrice: CycleDetails['monthlyFullPrice'];
  isCycleSelected: boolean;
  discount: number;
  logBi(): void;
  fullTermActualPrice: number;
  cycleId: CycleDetails['cycleId'];
}

const SaleDiscountBadgeComp: React.FunctionComponent<SaleDiscountBadgeProps> = (
  props,
) => {
  return (
    <PremiumCurrencyFormatter
      render={(formatCurrency) => (
        <BadgeContent {...props} formatCurrency={formatCurrency} />
      )}
    />
  );
};

interface BadgeContentProps extends SaleDiscountBadgeProps {
  formatCurrency: CurrencyAndFormatToString;
  rootStore: RootStore;
}
const BadgeContentComp: React.FC<BadgeContentProps> = ({
  formatCurrency,
  isCycleSelected,
  monthlyFullPrice,
  discount,
  rootStore,
}) => {
  const {
    isSaleProduct,
    appContext: { isLimitedTimeDiscount },
  } = rootStore.appStore;

  const { theme } = usePageModeContext();
  const isThemeDayful = theme === Theme.Dayful;
  const isWixStudio = theme === Theme.WixStudio;

  const stateClasses = isCycleSelected
    ? `bg-colors border-color ${isThemeDayful ? '' : isWixStudio ? 'studio-selected' : 'white-colors'}`
    : `${s.subscriptionPageSaleOptimisations8651} default-colors`;

  const badgeClassNames = classNames(s.discountBadge, stateClasses, theme);

  return (
    <div data-hook='sale-discount-badge' className={badgeClassNames}>
      <Text
        size='small'
        weight='bold'
        className={classNames(
          {
            'studio-selected': isCycleSelected && isWixStudio,
            'white-colors': isCycleSelected && !isThemeDayful && !isWixStudio,
            colors: !isCycleSelected,
          },
          theme,
        )}
      >
        {isLimitedTimeDiscount && !isSaleProduct ? (
          <Trans
            i18nKey='cycle_entry.sale_badge_save_discount'
            values={{ price: formatCurrency(monthlyFullPrice), discount }}
          >
            part 0 {{ discount }}%
          </Trans>
        ) : (
          <Trans
            i18nKey='cycle_entry.sale_badge_discount_only'
            values={{ price: formatCurrency(monthlyFullPrice), discount }}
          >
            part 0 {{ discount }}% Part 2
          </Trans>
        )}
      </Text>
    </div>
  );
};

const BadgeContent = withInjectedRootStore(BadgeContentComp);

export const SaleDiscountBadge = withExperiments(SaleDiscountBadgeComp);
